import React, {PropTypes} from 'react';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';
import InputField from '../../components/input-field/input-field';
import { SpinnerButton } from 'components/spinner-button/spinner-button';
import moment from 'moment';

class PaymentPaid extends React.Component {

  static propTypes = {
    invoice: PropTypes.object.isRequired,
    createInvoiceEmail: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props);

    this.state = {
      email: null,
      valid: false,
      emailSent: false,
      loading: false
    };
  }

  handleEmailInput = (name, object) => {
    this.setState({email: object.value, valid: object.valid, emailSent: false});
  }

  handleEmailSubmit = () => {
    this.setState({loading: true});

    if (this.state.valid) {
      let email = this.state.email.trim();
      this.props.createInvoiceEmail(email).then(() => {
        this.setState({
          emailSent: true,
          loading: false
        });
      }, () => {
        this.setState({
          loading: false
        });
      });
    }
  }

  renderEmailForm = () => (
    <div>
      <section className='email-invoice'>
        <InputField
          type='text'
          validationType='email'
          name='email'
          placeholder={proxyCounterpart('EMAIL')}
          showErrorWithoutBlur={false}
          callback={this.handleEmailInput}
          required='true'
          minLength='3'
          errorMessage={proxyCounterpart('EMAIL_ERROR')}
        />
      </section>
      <section className='buttons button-send-mail'>
        <SpinnerButton
          text={proxyCounterpart('EMAIL_INVOICE_SPECIFICATION')}
          loading={this.state.loading}
          classes='btn blue'
          disabled={!this.state.valid}
          callback={this.handleEmailSubmit}
        />
      </section>
    </div>
  )

  renderTime = (dateTime) => (
    <span>{moment(dateTime).calendar()}</span>
  )

  render = () => {
    return (
      <div className='payment-page'>
        <header>
          <Translate content='PAYMENT_PAID_TITLE'/>
        </header>
        <section className='logo'>
          <img src={require('images/logos/logo-blue-new.png')} alt='Frilans Finans-logotyp' />
        </section>

        {!this.state.emailSent &&
          <section className="main-text">
            <div className='thank-you'>
              <Translate content='PAYMENT_PAID_THANK_YOU_FOR_PAYMENT'/>
            </div>
            <div className='email'>
              <Translate content='PAYMENT_PAID_ENTER_EMAIL_FOR_INVOICE'/>
            </div>
          </section>
        }

        {this.state.emailSent &&
          <section className="main-text">
            <div className='email' dangerouslySetInnerHTML={
            {__html: proxyCounterpart('PAYMENT_PAID_EMAIL_INVOICE_SENT', { email: this.state.email }
            )}
            }/>
          </section>
        }
        {this.renderEmailForm()}
        <section className='close-page'>
          <Translate content="PAYMENT_PAID_CAN_CLOSE_PAGE"/>
        </section>
      </div>
    );
  }
}

export default PaymentPaid;



/** WEBPACK FOOTER **
 ** ./src/views/payment/payment-paid.js
 **/